import {
  IExternalSystemRegistrationResponse,
  IHaynesAutomaticLicenseLinkerResponse,
  IHaynesCustomerResponse,
  IHaynesLicensesResponse,
  IHaynesParamsResponse,
  IHaynesVOLTLicenseSearchResponse,
  ILicenseSearchInput,
  INewHaynesCustomer,
  INewHaynesLicense,
  createDistributor as createDistributorRequest,
  getDistributorByUUID as getDistributorByUUIDRequest,
  getDistributors as getDistributorsRequest,
  getExternalSystemsForCompanyRequest,
  getHaynesCustomerByClientIDRequest,
  getHaynesLicensesByCustomerRequest,
  getHaynesParamsRequest,
  postNewHaynesCustomerRequest,
  postNewHaynesLicenseRequest,
  postSearchHaynesVoltLicenseRequest,
  putExistingHaynesCustomerRequest,
  putTriggerHaynesProLinkerRequest,
  updateDistributor as updateDistributorRequest
} from '@cbgms/api/support'
import { IDistributor, IDistributorResponse, IDistributorUUIDResponse, IPaginatedRequest } from '@cbgms/api'

import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const getDistributors = (params: IPaginatedRequest) =>
  AsyncAction<IDistributorResponse>({
    type: [types.GET_DISTRIBUTORS, types.GET_DISTRIBUTORS_SUCCESS, types.GET_DISTRIBUTORS_FAILED],
    payload: {
      api: 'support',
      request: getDistributorsRequest(params)
    }
  })

export const getDistributorByUUID = (uuid: string) =>
  AsyncAction<IDistributorResponse>({
    type: [types.GET_DISTRIBUTOR, types.GET_DISTRIBUTOR_SUCCESS, types.GET_DISTRIBUTOR_FAILED],
    payload: {
      api: 'support',
      request: getDistributorByUUIDRequest(uuid)
    }
  })

export const createDistributor = (data: Partial<IDistributor>) =>
  AsyncAction<IDistributorUUIDResponse>({
    type: [types.CREATE_DISTRIBUTOR, types.CREATE_DISTRIBUTOR_SUCCESS, types.CREATE_DISTRIBUTOR_FAILED],
    payload: {
      api: 'support',
      request: createDistributorRequest(data)
    }
  })

export const updateDistributor = (uuid: string, data: Partial<IDistributor>) =>
  AsyncAction<IDistributorUUIDResponse>({
    type: [types.UPDATE_DISTRIBUTOR, types.UPDATE_DISTRIBUTOR_SUCCESS, types.UPDATE_DISTRIBUTOR_FAILED],
    payload: {
      api: 'support',
      request: updateDistributorRequest(uuid, data)
    }
  })

export const getHaynesCustomerByClientID = (distributorID: string, clientID: string) =>
  AsyncAction<IHaynesCustomerResponse>({
    type: [
      types.GET_HAYNES_CUSTOMER_BY_CLIENT_ID,
      types.GET_HAYNES_CUSTOMER_BY_CLIENT_ID_SUCCESS,
      types.GET_HAYNES_CUSTOMER_BY_CLIENT_ID_FAILED
    ],
    payload: {
      api: 'support',
      request: getHaynesCustomerByClientIDRequest(distributorID, clientID)
    }
  })

export const getHaynesParams = (distributorID: string) =>
  AsyncAction<IHaynesParamsResponse>({
    type: [types.GET_HAYNES_CUSTOMER_PARAMS, types.GET_HAYNES_CUSTOMER_PARAMS_SUCCESS, types.GET_HAYNES_CUSTOMER_PARAMS_FAILED],
    payload: {
      api: 'support',
      request: getHaynesParamsRequest(distributorID)
    }
  })
export const getHaynesVOLTLicenses = (distributorID: string, params: ILicenseSearchInput) =>
  AsyncAction<IHaynesVOLTLicenseSearchResponse>({
    type: [types.GET_HAYNES_VOLT_LICENSES, types.GET_HAYNES_VOLT_LICENSES_SUCCESS, types.GET_HAYNES_VOLT_LICENSES_FAILED],
    payload: {
      api: 'support',
      request: postSearchHaynesVoltLicenseRequest(distributorID, params)
    }
  })

export const postNewHaynesCustomer = (params: INewHaynesCustomer) =>
  AsyncAction<IHaynesParamsResponse>({
    type: [types.POST_NEW_HAYNES_CUSTOMER, types.POST_NEW_HAYNES_CUSTOMER_SUCCESS, types.POST_NEW_HAYNES_CUSTOMER_FAILED],
    payload: {
      api: 'support',
      request: postNewHaynesCustomerRequest(params)
    }
  })

export const putExistingHaynesCustomer = (params: INewHaynesCustomer) =>
  AsyncAction<IHaynesParamsResponse>({
    type: [types.POST_NEW_HAYNES_CUSTOMER, types.POST_NEW_HAYNES_CUSTOMER_SUCCESS, types.POST_NEW_HAYNES_CUSTOMER_FAILED],
    payload: {
      api: 'support',
      request: putExistingHaynesCustomerRequest(params)
    }
  })

export const postNewHaynesLicense = (params: INewHaynesLicense) =>
  AsyncAction<IHaynesParamsResponse>({
    type: [types.POST_NEW_HAYNES_LICENSE, types.POST_NEW_HAYNES_LICENSE_SUCCESS, types.POST_NEW_HAYNES_LICENSE_FAILED],
    payload: {
      api: 'support',
      request: postNewHaynesLicenseRequest(params)
    }
  })

export const getHaynesLicensesByCustomer = (
  distributorID: string,
  customerID: string,
  licenseSearchFlag: 'ActiveLicense' | 'InactiveLicense'
) =>
  AsyncAction<IHaynesLicensesResponse>({
    type: [
      types.GET_HAYNES_CUSTOMER_BY_CLIENT_ID,
      types.GET_HAYNES_CUSTOMER_BY_CLIENT_ID_SUCCESS,
      types.GET_HAYNES_CUSTOMER_BY_CLIENT_ID_FAILED
    ],
    payload: {
      api: 'support',
      request: getHaynesLicensesByCustomerRequest(distributorID, {
        CustomerID: customerID,
        LicenseSearchFlag: licenseSearchFlag,
        IncludeCustomerData: false,
        IncludeShopData: false
      })
    }
  })

export const getExternalSystemsForCompany = (companyUUID: string, externalSystems?: string[]) =>
  AsyncAction<IExternalSystemRegistrationResponse>({
    type: [
      types.GET_EXTERNAL_SYSTEM_FOR_COMPANY,
      types.GET_EXTERNAL_SYSTEM_FOR_COMPANY_SUCCESS,
      types.GET_EXTERNAL_SYSTEM_FOR_COMPANY_FAILED
    ],
    payload: {
      api: 'support',
      request: getExternalSystemsForCompanyRequest(companyUUID, externalSystems || [])
    }
  })

export const putTriggerHaynesProLinker = (distributorUUID: string) =>
  AsyncAction<IHaynesAutomaticLicenseLinkerResponse>({
    type: [types.POST_TRIGGER_HAYNESPRO_LINKER, types.POST_TRIGGER_HAYNESPRO_LINKER_SUCCESS, types.POST_TRIGGER_HAYNESPRO_LINKER_FAILED],
    payload: {
      api: 'support',
      request: putTriggerHaynesProLinkerRequest(distributorUUID)
    }
  })
